(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-product"]) return;
  try {
    
  if (!customElements.get('b2b-product-gallery')) {
    customElements.define('b2b-product-gallery', class extends HTMLElement {
      connectedCallback() {
        const images = Array.from(this.querySelectorAll('[data-b2b-image]'));
        const thumbnails = Array.from(this.querySelectorAll('[data-b2b-thumbnail]'));
        const select = (id) => {
          images.forEach(image => { image.hidden = image.dataset.b2bImage !== id; });
          thumbnails.forEach(thumbnail => {
            if (thumbnail.dataset.b2bThumbnail === id) thumbnail.setAttribute('aria-current', 'true');
            else thumbnail.removeAttribute('aria-current');
          });
        };
        if (images.length) select(images[0].dataset.b2bImage);
        this.onclick = (event) => {
          const thumbnail = event.target.closest('[data-b2b-thumbnail]');
          if (!thumbnail) return;
          event.preventDefault();
          select(thumbnail.dataset.b2bThumbnail);
        };
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
